export interface CropConfiguration {
    id: number;
    crop_name: string;
    crop_key: string;
    growth_stages: string[];
    planting_form_fields: string[];
    default_planting_date: string;
    harvest_unit_per_acres: string;
    stages: CropStage[];
}

export interface CropStage {
    id: number;
    growth_stage: string;
    dssat_stage: string;
    raw_dssat_stage: string;
    temperature_threshold: number;
    temperature_maximum: number;
    days_after_planting: number;
    growing_degree_days: number;
    nitrogen_flux: number;
    nitrogen_response: boolean;
    insights_active: boolean;
    notifications_active: boolean;
    vegetation_index: string;
    kcb: number;
    evapotranspiration_phase: string;
    si_excess: number;
    si_sufficient: number;
    si_deficient: number;
    high_sensitivity_translation: number;
    low_sensitivity_translation: number;
    crop_configuration_id: number;
}

export interface CropStageSummary {
    id: number;
    growth_stage: string;
}

export const CORN_CROP_KEY = "corn";
